import TableExportPanel from './TableExportPanel.component';

export default TableExportPanel;
